import { render, staticRenderFns } from "./new_shipping.vue?vue&type=template&id=2922a512&scoped=true"
import script from "./new_shipping.vue?vue&type=script&lang=js"
export * from "./new_shipping.vue?vue&type=script&lang=js"
import style0 from "./new_shipping.vue?vue&type=style&index=0&id=2922a512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922a512",
  null
  
)

export default component.exports